import { KeyboardEvent, useEffect, useRef, useState } from "react";

type Props = {
    inputCount: number
    onChange: (value: string) => void
    error?: string
}

const OtpInput = ({ inputCount, onChange, error }: Props) => {
    const [otp, setOtp] = useState<Array<string | number>>(new Array(inputCount).fill(""));

    const inputReferences = useRef<HTMLInputElement[]>([]);

    const handleChange = (value: string | number, index: number) => {
        let newArr = [...otp];
        newArr[index] = value;
        setOtp(newArr);

        if(value && index < inputCount - 1){
            inputReferences.current[index + 1].focus()
        }
    }

    useEffect(() => {
        if(otp.length == inputCount) {
            onChange(otp.join(""));
        }
    }, [otp])

    const handleBackSpaceEnter = (event: KeyboardEvent<HTMLInputElement>, index: number) => {
        // @ts-ignore
        if(event.key === "Backspace" && !event.target.value && index > 0){
            inputReferences.current[index - 1].focus()
        }

        // @ts-ignore
        if(event.key === "Enter" && event.target.value && index < inputCount -1){
            inputReferences.current[index + 1].focus()
        }
    }

    return (
        <div>
            <div className="flex justify-center items-center gap-4">
            {
                otp.map((digit, index) => (
                    <input 
                        key={index} 
                        value={digit}
                        maxLength={1}  
                        onChange={(e) => handleChange(e.target.value, index)}
                        onKeyUp={(e) => handleBackSpaceEnter(e, index)}
                        ref={(ref) => {
                            if(ref !== null) inputReferences.current[index] = ref
                        }}
                        className="w-14 h-14 text-lg text-center rounded-md border border-zinc-200 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary focus:ring-offset-1"
                    />
                ))
            }
            </div>

            {
                error &&
                <div className="text-xs text-rose-800 font-medium px-1 pt-1">
                    { error ? error : "field is required" }
                </div>
            }
        </div>
    );
}

export default OtpInput